<div class="text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if(question?.required) {
        <span 
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span>
      }
    </h6>
  </div>

  <div class="rank-order-container">
    <div class="rank-order-list">
      @for(item of rankedItems; track item.optionId; let i = $index) {
        <div 
          class="rank-order-item"
          [class.dragging]="draggedIndex === i"
          [class.disabled]="disabled"
          [attr.draggable]="!disabled"
          (click)="$event.stopPropagation()"
          (dragstart)="onDragStart($event, item, i)"
          (dragover)="onDragOver($event)"
          (dragenter)="onDragEnter($event)"
          (drop)="onDrop($event, i)"
          (dragend)="onDragEnd($event)">
          
          <div class="rank-order-item-content">
            <!-- <div class="rank-order-item-rank" [class]="getRankClass(item.currentRank)">
              <span class="rank-icon">{{ getRankIcon(item.currentRank) }}</span>
            </div> -->
            <!-- <div class="rank-order-item-rank" >
              <span class="rank-number">{{ item.currentRank }}</span>
            </div> -->
            
            <div class="rank-order-item-text">
              <span class="item-label"
              [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
              [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
              [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
              [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
              >{{ item.text | titlecase }}</span>
            </div>
            
            <div class="rank-order-item-controls">
              <button 
                class="control-btn up-btn"
                [disabled]="i === 0"
                (click)="moveItemUp(i)"
                title="Move up">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="18,15 12,9 6,15"></polyline>
                </svg>
              </button>
              
              <button 
                class="control-btn down-btn"
                [disabled]="i === rankedItems.length - 1"
                (click)="moveItemDown(i)"
                title="Move down">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
              </button>
              
              <div class="drag-handle" title="Drag to reorder">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
